import { Component, OnInit } from '@angular/core';
import { SpacesService } from '../services/spaces.service';

@Component({
  selector: 'app-spaces',
  templateUrl: './spaces.component.html',
  styleUrls: ['./spaces.component.scss']
})
export class SpacesComponent implements OnInit {
  private spaces;
  private filteredSpaces;
  private tagsList;
  private activeTags;

  private isFiltersOpen;

  private sortAlgorithm;

  constructor(
    private spacesService: SpacesService
  ) {
    this.spaces = this.spacesService.getSpaces();
   }

  ngOnInit() {
    
    this.isFiltersOpen = false;
    this.tagsList = [];
    this.activeTags = [];
    this.spaces.forEach( (space) => {
      const tags = space.tags;
      tags.forEach( (tag) => {
        if (this.tagsList.indexOf(tag)  === -1) {
          this.tagsList.push(tag);
        }
      });
    });
    this.sortAlgorithm = 'alpha';
    this.filterSpaces();
  }

  toggleTag(tag) {
    if (this.activeTags.indexOf(tag)  === -1) {
      this.activeTags.push(tag);
    } else {
      this.activeTags.splice(this.activeTags.indexOf(tag),1);
    }
    this.filterSpaces();
  }

  filterSpaces() {
    const algorithms = {
      alpha: (a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      },
      zeta: (a, b) => {
        if (a.name > b.name) {
          return -1;
        }
        if (a.name < b.name) {
          return 1;
        }
        return 0;
      }
    };
    
    this.filteredSpaces = this.spaces.filter( (space) => {
      for (const tag of this.activeTags) {
        if (space.tags.indexOf(tag) === -1) {
          return false;
        }
      }
      return true;
    }).sort(algorithms[this.sortAlgorithm]);
  }

  toggleFilters() {
    this.isFiltersOpen = !this.isFiltersOpen;
  }

  toggleOrder() {
    this.sortAlgorithm = this.sortAlgorithm === 'alpha' ? 'zeta' : 'alpha';
    this.filterSpaces();
  }

}



// WEBPACK FOOTER //
// ./src/app/spaces/spaces.component.ts